import {
	useAddTicketCommentMutation,
	useUploadTicketAttachmentMutation,
} from "@/pages/Private/redux/tickets/tickets.api";

export type ReplyOutcome = { ok: true; failedAttachment?: string } | { ok: false };

/**
 * A reply with files is create-then-upload (PREC-3938 decision 2): the API attaches only to the
 * uploader's own MESSAGE row, whose id comes back with the reply. A failed upload never discards
 * the reply the customer just wrote; the caller reports which file did not make it.
 */
export const useTicketReply = (ticketId: number) => {
	const [addComment, { isLoading: isPosting }] = useAddTicketCommentMutation();
	const [uploadAttachment, { isLoading: isUploading }] = useUploadTicketAttachmentMutation();

	const send = async (message: string, files: File[]): Promise<ReplyOutcome> => {
		let commentId: number;

		try {
			commentId = (await addComment({ ticketId, message }).unwrap()).comment.id;
		} catch {
			return { ok: false };
		}

		let failedAttachment: string | undefined;

		for (const file of files) {
			try {
				await uploadAttachment({ ticketId, commentId, file }).unwrap();
			} catch {
				failedAttachment = file.name;
				break;
			}
		}

		return { ok: true, failedAttachment };
	};

	return { send, isSending: isPosting || isUploading };
};
